import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBusBlue = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 16,
	viewBox: "0 0 14 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M14 2.5C14 1.125 10.875 0 7 0C3.09375 0 0 1.125 0 2.5V13C0 13.5625 0.4375 14 1 14V15C1 15.5625 1.4375 16 2 16H3C3.53125 16 4 15.5625 4 15V14H10V15C10 15.5625 10.4375 16 11 16H12C12.5312 16 13 15.5625 13 15V14H13.1875C13.6875 14 14 13.625 14 13.2188V2.5ZM2.5 12.5C1.9375 12.5 1.5 12.0625 1.5 11.5C1.5 10.9688 1.9375 10.5 2.5 10.5C3.03125 10.5 3.5 10.9688 3.5 11.5C3.5 12.0625 3.03125 12.5 2.5 12.5ZM3 9C2.4375 9 2 8.5625 2 8V4C2 3.46875 2.4375 3 3 3H11C11.5312 3 12 3.46875 12 4V8C12 8.5625 11.5312 9 11 9H3ZM11.5 12.5C10.9375 12.5 10.5 12.0625 10.5 11.5C10.5 10.9688 10.9375 10.5 11.5 10.5C12.0312 10.5 12.5 10.9688 12.5 11.5C12.5 12.0625 12.0312 12.5 11.5 12.5Z",
		fill: "#448AFF"
	})]
});
const ForwardRef = forwardRef(SvgBusBlue);
export { ForwardRef as ReactComponent };
